<template>

  <footer class="footer" data-nosnippet>

    <!--<section class="footer-group footer-group-topics">
        <div class="footer-group-left"></div>
        <div class="footer-group-center">

            <nav class="footer-topics d-none d-sm-block d-md-block d-lg-block d-xl-block">
                <table>
                    <tbody>
                        <tr v-for="menuItemRows in arrayTable.createFromArray(menusData['footer-menu-topics'] || [], 3)">
                            <td v-for="menuItem in menuItemRows">
                                <a
                                        :href="wpApi.stripBaseUrl(menuItem['url'])"
                                        v-if="menuItem"
                                >
                                    {{ wpApi.decodeHtmlEntityAmpersand(menuItem['title']) }}
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </nav>
            <nav class="footer-topics d-block d-sm-none d-md-none d-lg-none d-xl-none">
                <table>
                    <tbody>
                        <tr v-for="menuItemRows in arrayTable.createFromArray(menusData['footer-menu-topics'] || [], 2)">
                            <td v-for="menuItem in menuItemRows">
                                <a
                                        :href="wpApi.stripBaseUrl(menuItem['url'])"
                                        v-if="menuItem"
                                >
                                    {{ wpApi.decodeHtmlEntityAmpersand(menuItem['title']) }}
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </nav>

        </div>
        <div class="footer-group-right"></div>
    </section>-->

<!--    <section class="footer-group footer-group-brand-copyright-social">-->
<!--      <div class="footer-group-left">-->
<!--        <div class="footer-brand">-->
<!--          <a-->
<!--              href="https://www.gilead.com"-->
<!--              target="_blank"-->
<!--              rel="noopener"-->
<!--          >-->
<!--            <img src="/img/ic_gilead_ffffff.svg" alt="Gilead Sciences">-->
<!--          </a>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="footer-group-center">-->
<!--        <div class="footer-copyright">-->
<!--          © {{ new Date().getFullYear() }} Gilead Sciences GmbH Deutschland-->
<!--        </div>-->
<!--      </div>-->
      <!--<div class="footer-group-right">
          <div class="footer-social">
              <a
                      href="https://www.facebook.com/"
                      target="_blank"
                      rel="noopener"
                      class="footer-social-icon"
              >
                  <img src="/img/ic_facebook_ffffff.svg" alt="Facebook">
              </a>
              <a
                      href="https://twitter.com/"
                      target="_blank"
                      rel="noopener"
                      class="footer-social-icon"
              >
                  <img src="/img/ic_twitter_ffffff.svg" alt="Twitter">
              </a>
          </div>
      </div>-->
<!--    </section>-->

    <!--        <section class="footer-group footer-group-legal">-->
    <!--            <div class="footer-group-left">-->
    <!--                <nav class="footer-legal">-->

    <!--                  <template v-for="menuItem in menusData['footer-menu-legal']">-->
    <!--                    <a v-if="wpApi.isExternalUrl(menuItem['url'])"-->
    <!--                       :href="menuItem['url']"-->
    <!--                       :class="menuItem['classes'].join(' ')">{{ wpApi.decodeHtmlEntityAmpersand(menuItem['title']) }}</a>-->
    <!--                    <a v-else-->
    <!--                            :key="menuItem['ID']"-->
    <!--                            :href="wpApi.stripBaseUrl(menuItem['url'])"-->
    <!--                    >-->
    <!--                        {{ wpApi.decodeHtmlEntityAmpersand(menuItem['title']) }}-->
    <!--                    </a>-->
    <!--                  </template>-->
    <!--                    <a href="#" class="ot-sdk-show-settings">Cookie-Einstellungen</a>-->
    <!--                </nav>-->
    <!--            </div>-->
    <!--        </section>-->

    <!--        <section class="footer-group footer-group-legal-text">-->
    <!--            <div class="footer-legal-text">-->
    <!--                <p-->
    <!--                        v-html="options['global-fields']['fields']['global_footer_legal_text']"-->
    <!--                        v-if="options['global-fields']"-->
    <!--                ></p>-->
    <!--            </div>-->
    <!--        </section>-->
    <section class="footer-group footer-group-brand py-5 pb-2">
      <div class="footer-group-row gx-2 gy-4">
        <!-- 1 · Logo + CTA -->
        <div v-if="footerColumns.column1"
             class="footer-col footer-brand col-logo ms-2 col-12 col-sm-6 col-md-4 col-lg-2 mb-4 mb-lg-0 text-lg-start p-0">
          <img
              v-if="footerColumns.column1.logo"
              :src="footerColumns.column1.logo.url"
              :alt="footerColumns.column1.logo.alt || 'Logo'"
              class="footer-logo"
          />
          <a
              v-if="footerColumns.column1.button_url && footerColumns.column1.button_text"
              :href="footerColumns.column1.button_url"
              class="btn btn-primary"
          >
            {{ footerColumns.column1.button_text }}
          </a>
        </div>

        <!-- 2–4 · Headings + links -->
        <template
            v-for="i in [2, 3, 4]"
            v-if="footerColumns[`column${i}`]"
        >
          <div
              :class="[
          'col-12', 'col-sm-6', 'col-md-4',
          i === 3 ? 'col-lg-3' : 'col-lg-2',
          'mb-1', 'mb-lg-0', 'footer-col', 'ml-lg-4', 'ml-md-0', 'mt-4', 'mt-lg-0'
          ]"
          >
            <h5 class="mb-3">{{ footerColumns[`column${i}`].heading }}</h5>
            <ul>
              <li
                  v-for="link in footerColumns[`column${i}`].links"
                  :key="link.link.url"
                  class="mb-2 menu-footer-menu"
              >
                <a
					:href="link.link.url"
					:target="link.link.target || null"
					:rel="link.link.target === '_blank' ? 'noopener' : null"
					:class="[
						'text-decoration-none',
						'menu-item',
						'menu-item-type-post_type',
						'menu-item-object-page',
						link.css_class
					]"
					>
                  {{ link.link.title }}
                </a>
              </li>
            </ul>
          </div>
          <div
              v-if="i < 4"
              :key="`hr-${i}`"
              class="col-12 mb-1 d-lg-none d-md-none d-sm-none mt-4"
          >
            <hr class="footer-divider"/>
          </div>
        </template>


        <div class="col-12 mb-1 d-lg-none d-md-none d-sm-none mt-0">
          <hr class="footer-divider"/>
        </div>

        <!-- 5 · Socials -->
        <div
            v-if="footerColumns.column5"
            class="footer-col social-icons col-12 col-sm-6 col-md-4 col-lg-2 mb-4 mb-lg-0 text-left social-media-icons ml-lg-0 ml-md-0 mt-4 mt-lg-0"
        >
          <h5 class="font-bold mb-3">{{ footerColumns.column5.heading }}</h5>
          <div class="d-flex gap-3">
            <a
                v-for="platform in ['linkedin', 'youtube', 'instagram', 'facebook']"
                :key="platform"
                v-if="footerColumns.column5[platform + '_url'] && footerColumns.column5[platform + '_icon']"
                :href="footerColumns.column5[platform + '_url']"
                target="_blank"
                rel="noopener"
            >
              <img
                  :src="footerColumns.column5[platform + '_icon'].url"
                  :alt="platform"
                  class="img-fluid"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
    <section class="footer-group footer-group-brand-copyright">
      <!-- Copyright -->
      <div v-if="footerColumns.copyright_notice" class="footer-copyright">
        <div class="py-2 footer-col">
          <small>© {{ new Date().getFullYear() }} {{ footerColumns.copyright_notice }}</small>
        </div>
      </div>
    </section>

  </footer>

</template>

<script>

// console.log('AppFooter');

import arrayTable from '../services/arrayTable';
import wpApi from '../services/wpApi';

export default {
  props: {
    footerData: {
      type: Object,
      default: () => ({})
    },
	menus: {
        type: Object,
        default: () => ({})
    }
  },
  updated: function () {
    this.$nextTick(function () {
      this.markLinksAsExternal();
      this.replaceCookieSettingItem(
          "Cookie-Einstellungen verwalten",
          "ot-sdk-show-settings"
      );
    });
  },
  components: {},
  computed: {
    options() {
      // Fallback to root cache if available (for SPA compatibility)
      return this.$root && this.$root.cache ? this.$root.cache.options : {};
    },
    footerColumns() {
      // First check if data was passed via props from PHP
      if (this.footerData && Object.keys(this.footerData).length > 0) {
        return this.footerData;
      }
      // Fallback to root cache for SPA compatibility
      if (
          this.options &&
          this.options['global-fields'] &&
          this.options['global-fields'].fields
      ) {
        return this.options['global-fields'].fields;
      }
      return {};
    },
  },
  data() {
    return {
      arrayTable,
      wpApi,
    };
  },
  methods: {
    markLinksAsExternal() {
      const socialLinks = this.$el.querySelectorAll('.social-media-icons a');

      socialLinks.forEach((a) => {
        a.classList.add('link-external');
        a.addEventListener('click', (event) => {
          event.preventDefault();
          this.$root.states.popupExternalLinkHref = a.href;
        });
      });
    },
    replaceCookieSettingItem(targetText, anchorClass) {
      const listItems = this.$el.querySelectorAll("li.menu-footer-menu");

      listItems.forEach((li) => {
        const anchor = li.querySelector("a");
        if (anchor && anchor.textContent.trim() === targetText) {
          const newAnchor = document.createElement("a");
          newAnchor.href = "javascript:void(0);";
          newAnchor.textContent = targetText;
          newAnchor.className = anchorClass;
          newAnchor.style.cursor = "pointer";

          const newLi = document.createElement("li");
          newLi.className = "menu-footer-menu";
          newLi.appendChild(newAnchor);

          li.parentNode.replaceChild(newLi, li);
        }
      });
    },
  },
}

</script>

<style lang="scss">

@import '../../css/variables';

.footer {
  background-color: $color-nochvielvor-black;
  .footer-group {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    @media screen and (min-width: 1200px) {
      padding: 1.5rem * $factor-1200;
    }
    @media screen and (min-width: 1440px) {
      padding: 1.5rem * $factor-1440;
    }
    @media screen and (min-width: 1920px) {
      padding: 1.5rem * $factor-1920;
    }
    @media screen and (min-width: 2400px) {
      padding: 1.5rem * $factor-2400;
    }

    &.footer-group-topics {
      background-color: $color-nochvielvor-pink-light;
    }

    &.footer-group-brand {
      background-color: $color-nochvielvor-black;
      color: $color-nochvielvor-white;

      .footer-group-row {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        margin: 0 auto;
      }

      h5 {
        font-size: 1.5rem;
        @media screen and (min-width: 1440px) {
          font-size: 0.85rem * $factor-1440;
        }
        @media screen and (min-width: 1920px) {
          font-size: 0.75rem * $factor-1920;
        }
        @media screen and (min-width: 2400px) {
          font-size: 0.7rem * $factor-2400;
        }
      }

      ul {
        margin: 0;
        padding: 0;
        list-style: none;

        li {
          line-height: 24px;

          a {
            text-decoration: none;
            color: $color-nochvielvor-white;
            font-size: 1rem;
            @media screen and (max-width: 767px) {
              font-size: 1.4rem * $factor-720;
            }
            @media screen and (min-width: 1200px) {
              font-size: 0.8rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
              font-size: 0.66rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
              font-size: 0.625rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
              font-size: 0.5rem * $factor-2400;
            }
          }
        }
      }

      .footer-divider {
        width: 40px;
        border-top: 2px solid $color-nochvielvor-white;
        margin: 0.75rem 0;
        opacity: 1;
        background-color: $color-nochvielvor-white;
      }

      .social-media-icons {
        img {
          width: 2.5rem;
          height: 2.5rem;
          @media screen and (max-width: 767px) {
            width: 3.4rem * $factor-720;
            height: 3.4rem * $factor-720;
          }
          @media screen and (min-width: 1200px) {
            width: 2rem * $factor-1200;
            height: 2rem * $factor-1200;
          }
          @media screen and (min-width: 1440px) {
            width: 2rem *  $factor-1440;
            height: 2rem * $factor-1440;
          }
          @media screen and (min-width: 1920px) {
            width: 2rem *  $factor-1920;
            height: 2rem * $factor-1920;
          }
          @media screen and (min-width: 2400px) {
            width: 2.5rem *  $factor-2400;
            height: 2.5rem * $factor-2400;
          }
        }

        a {
          &:first-child {
            padding-left: 0;
          }

          padding: 0 10px;
        }
      }
    }

    &.footer-group-brand-copyright-social {
      background-color: $color-nochvielvor-pink;
      @media screen and (max-width: 767px) {
        display: block;
      }
    }

    &.footer-group-brand-copyright {
      background-color: $color-nochvielvor-black;
      color: $color-nochvielvor-white;
    }

    &.footer-group-legal {
      background-color: $color-nochvielvor-black;
    }

    &.footer-group-legal-text {
      padding-top: 0;
      background-color: $color-nochvielvor-black;
    }

    .footer-group-left {
      flex: 1;
      @media screen and (max-width: 767px) {
        align-self: flex-start;
        width: 100%;
      }
    }

    .footer-group-center {
      @media screen and (max-width: 767px) {
        align-self: flex-start;
        width: 100%;
      }
    }

    .footer-group-right {
      flex: 1;
      @media screen and (max-width: 767px) {
        align-self: flex-start;
        width: 100%;
      }
    }
  }

  .footer-topics {
    a {
      color: $color-nochvielvor-black;
      font-size: 0.9375rem;
      font-weight: bold;
      line-height: 2;
      text-decoration: none;
      white-space: nowrap;
      @media screen and (max-width: 767px) {
        font-size: 0.9375rem * $factor-720;
        font-weight: 500;
      }
      @media screen and (min-width: 1200px) {
        font-size: 0.9375rem * $factor-1200;
      }
      @media screen and (min-width: 1440px) {
        font-size: 0.9375rem * $factor-1440;
      }
      @media screen and (min-width: 1920px) {
        font-size: 0.9375rem * $factor-1920;
      }
      @media screen and (min-width: 2400px) {
        font-size: 0.9375rem * $factor-2400;
      }
    }

    table {
      margin: 0 auto;

      tbody {
        tr {
          td {
            padding: 0 1rem;
            @media screen and (max-width: 767px) {
              &:first-child {
                padding-left: 0;
              }
              &:last-child {
                padding-right: 0;
              }
            }
            @media screen and (min-width: 1200px) {
              padding: 0 1rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
              padding: 0 1rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
              padding: 0 1rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
              padding: 0 1rem * $factor-2400;
            }
          }
        }
      }
    }
  }

  .footer-brand {
    width: 5.25rem;
    @media screen and (max-width: 767px) {
      margin: 0 auto 1rem auto;
    }
    @media screen and (min-width: 1200px) {
      width: 5.25rem * $factor-1200;
    }
    @media screen and (min-width: 1440px) {
      width: 5.25rem * $factor-1440;
    }
    @media screen and (min-width: 1920px) {
      width: 5.25rem * $factor-1920;
    }
    @media screen and (min-width: 2400px) {
      width: 5.25rem * $factor-2400;
    }

    img {
      width: 100%;
      height: auto;
      max-width: 190px;
    }
  }

  .footer-copyright {
    color: $color-nochvielvor-white;
    font-size: 0.65rem;
    text-align: center;
    text-transform: inherit;
    @media screen and (max-width: 767px) {
      margin-bottom: 1rem;
      font-size: 0.75rem * $factor-720;
    }
    @media screen and (min-width: 1200px) {
      font-size: 0.65rem * $factor-1200;
    }
    @media screen and (min-width: 1440px) {
      font-size: 0.65rem * $factor-1440;
    }
    @media screen and (min-width: 1920px) {
      font-size: 0.65rem * $factor-1920;
    }
    @media screen and (min-width: 2400px) {
      font-size: 0.65rem * $factor-2400;
    }
  }

  .footer-social {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    @media screen and (max-width: 767px) {
      justify-content: center;
    }

    .footer-social-icon {
      display: block;
      width: 1.25rem;
      height: 1.25rem;
      margin: 0 0.25rem;
      @media screen and (min-width: 1200px) {
        width: 1.25rem * $factor-1200;
        height: 1.25rem * $factor-1200;
        margin: 0 0.25rem * $factor-1200;
      }
      @media screen and (min-width: 1440px) {
        width: 1.25rem * $factor-1440;
        height: 1.25rem * $factor-1440;
        margin: 0 0.25rem * $factor-1440;
      }
      @media screen and (min-width: 1920px) {
        width: 1.25rem * $factor-1920;
        height: 1.25rem * $factor-1920;
        margin: 0 0.25rem * $factor-1920;
      }
      @media screen and (min-width: 2400px) {
        width: 1.25rem * $factor-2400;
        height: 1.25rem * $factor-2400;
        margin: 0 0.25rem * $factor-2400;
      }

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      img {
        width: 100%;
        height: auto;
      }
    }
  }

  .footer-legal {
    a {
      display: inline-block;
      margin: 0 0.75rem;
      color: $color-nochvielvor-white;
      font-size: 0.75rem;
      text-decoration: none;
      @media screen and (max-width: 767px) {
        display: block;
        margin-left: 0;
        line-height: 2;
      }
      @media screen and (min-width: 1200px) {
        margin: 0 0.75rem * $factor-1200;
        font-size: 0.75rem * $factor-1200;
      }
      @media screen and (min-width: 1440px) {
        margin: 0 0.75rem * $factor-1440;
        font-size: 0.75rem * $factor-1440;
      }
      @media screen and (min-width: 1920px) {
        margin: 0 0.75rem * $factor-1920;
        font-size: 0.75rem * $factor-1920;
      }
      @media screen and (min-width: 2400px) {
        margin: 0 0.75rem * $factor-2400;
        font-size: 0.75rem * $factor-2400;
      }

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .footer-legal-text {
    a {
      color: $color-nochvielvor-pink;
      text-decoration: none;
    }

    p {
      color: $color-nochvielvor-white;
      font-size: 0.5rem;
      text-decoration: none;
      @media screen and (min-width: 1200px) {
        font-size: 0.5rem * $factor-1200;
      }
      @media screen and (min-width: 1440px) {
        font-size: 0.5rem * $factor-1440;
      }
      @media screen and (min-width: 1920px) {
        font-size: 0.5rem * $factor-1920;
      }
      @media screen and (min-width: 2400px) {
        font-size: 0.5rem * $factor-2400;
      }
    }
  }
}

</style>
